import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import { Link } from 'react-router-dom';
import { Gradient, Grain } from '@material-ui/icons';
import { Divider } from '@material-ui/core';

export const Menu: React.FC = () => {
  return (
    <div className="DashboardMenu">
      <Link to="/admin/">
        <ListItem button>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
      </Link>
      <Link to="/admin/users">
        <ListItem button>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItem>
      </Link>
<Divider/>
      <ListSubheader inset>Data Logs</ListSubheader>
      <Link to="/admin/rainfall">
        <ListItem button>
          <ListItemIcon>
            <Grain />
          </ListItemIcon>
          <ListItemText primary="Rainfall" />
        </ListItem>
      </Link>
      <Link to="/admin/riverlevel">
      <ListItem button>
        <ListItemIcon>
          <Gradient />
        </ListItemIcon>
        <ListItemText primary="River Level" />
      </ListItem>
      </Link>
      <Divider/>
      <ListSubheader inset>Guages</ListSubheader>
      <Link to="/admin/raingauge">
      <ListItem button>
        <ListItemIcon>
          <Grain />
        </ListItemIcon>
        <ListItemText primary="Rain Gauges" />
      </ListItem>
      </Link>
      <Link to="/admin/riverscale">
      <ListItem button>
        <ListItemIcon>
          <Gradient />
        </ListItemIcon>
        <ListItemText primary="River Scales" />
      </ListItem>
      </Link>
    </div>
  );
}